import { message } from 'ant-design-vue';
import axios from 'axios';

import store from '../store';

const service = axios.create({
  timeout: 600000,
});

service.interceptors.request.use(
  (config) => {
    const token = store.getters.getToken;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('request: ', error); // for debug
    Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.data.code == 2000) {
      window.location.reload();
    } else if (response.data.code == 30007) {
      window.location.href = '/index';
    }
    return response.data;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      message.error('Request timed out...');
    }
    console.error('response error:', error);
    return Promise.reject(error);
  }
);

export default service;
